import { Controller } from "@hotwired/stimulus";

const targetFor = (target) => {
  return `[data-booking-preferences-date-time-target="${target}"]`;
};

export default class extends Controller {
  static targets = ['row', 'date', 'time'];

  connect() {
    this.rawDateOptions = this.dateOptions;

    this.dateTargets.forEach((dateElm) => {
      this.updateDateOptions(dateElm);
      this.updateTimeOptions(dateElm);
    });
  }

  change(event) {
    const dateSelectElm = event.target;

    this.updateDateOptions(dateSelectElm);

    this.updateTimeOptions(dateSelectElm);
  }

  updateDateOptions(dateSelectElm) {
    this.selectedDates = [];
    this.dateTargets.forEach((dateElm) => {
      const dateElmValue = dateElm.selectedOptions[0].value;
      if (dateElmValue !== '') this.selectedDates.push(dateElmValue);
      if (dateSelectElm === dateElm) return;

      dateElm.innerHTML = '';
      this.rawDateOptions.forEach((optionElm) => {
        if (dateElmValue !== optionElm.value && this.selectedDates.includes(optionElm.value))
          return;

        let tmp = document.createElement('option');
        tmp.innerHTML = optionElm.text;
        tmp.value = optionElm.value;
        tmp.selected = optionElm.value == dateElmValue;
        if (optionElm.intervals) tmp.dataset.intervals = optionElm.intervals;
        dateElm.appendChild(tmp);
      });
    });
  }

  parentRow(elm) {
    return elm.closest(targetFor('row'));
  }

  updateTimeOptions(dateSelectElm) {
    const timeSelectElm = this.parentRow(dateSelectElm).querySelector(targetFor('time'));
    const intervals = JSON.parse(this.selectedOption(dateSelectElm).dataset.intervals || '[]');

    const selectedTimeInterval = timeSelectElm.dataset.selectedInterval;

    const html = intervals.map(function (interval) {
      return `<option value="${interval}" ${interval == selectedTimeInterval && 'selected'}>${interval}</option>`;
    });

    if (timeSelectElm.dataset.blankOption != '') {
      const blankOption = `<option value="">${timeSelectElm.dataset.blankOption}</option>`;
      html.unshift(blankOption);
    }

    timeSelectElm.innerHTML = html.join('');
  }

  selectedOption(el) {
    return el.selectedOptions[0];
  }

  get dateOptions() {
    const dateOptionElements = this.dateTargets[0].querySelectorAll('option');

    return Array.apply(null, dateOptionElements).map((option) => {
      return { value: option.value, text: option.text, intervals: option.dataset.intervals };
    });
  }
}
